import map from 'lodash/map';

import SelectIcon from '~/components/icons/SelectIcon';
import { countryNames } from '~/lib/helpers';

import styles from './Field.style';
import { HIDDEN_TYPES, replaceLinks } from './Utils';

class Field extends React.Component {
  getClassName = () => {
    const { classes, isDragging, isSelected } = this.props;

    return classnames(classes.root, {
      [classes.dragging]: isDragging,
      [classes.selected]: isSelected,
    });
  };

  getInputClassName = () => {
    const { field, classes, isSelected } = this.props;

    return classnames(classes.input, {
      [classes.multiline]: field.type === 'textarea',
      [classes.selectedInput]: isSelected,
    });
  };

  getLabelClassName = () => {
    const { classes, isSelected } = this.props;

    return classnames(classes.label, {
      [classes.labelSelected]: isSelected,
    });
  };

  isHidden(field) {
    return HIDDEN_TYPES.includes(field.type);
  }

  renderCheckboxInput() {
    const { field, classes } = this.props;

    const children = replaceLinks(field.description);

    return (
      <div className={classes.checkbox}>
        <input type="checkbox" checked disabled />
        {field.description && (
          <p className={classes.checkboxDescription}> {children} </p>
        )}
      </div>
    );
  }

  renderPlaceholderInput() {
    const { field } = this.props;

    return <div className={this.getInputClassName()}>{field.placeholder}</div>;
  }

  renderSelectInput() {
    const { field, classes } = this.props;
    const options = field.select_options || [];

    return (
      <div className={classes.select}>
        <select className={classes.selectInput}>
          <option key={-1} />
          {options.map((option, i) => (
            <option key={i}>{option}</option>
          ))}
        </select>

        <SelectIcon className={classes.selectArrow} />
      </div>
    );
  }

  renderCompanySize() {
    const { classes } = this.props;

    return (
      <div className={classes.select}>
        <select className={classes.selectInput}>
          <option />
          <option value="1-10">1-10</option>
          <option value="11-50">11-50</option>
          <option value="51-250">51-250</option>
          <option value="251-1K">251-1K</option>
          <option value="1K-5K">1K-5K</option>
          <option value="5K-10K">5K-10K</option>
          <option value="10K-50K">10K-50K</option>
          <option value="50K-100K">50K-100K</option>
          <option value="100K+">100K+</option>
        </select>

        <SelectIcon className={classes.selectArrow} />
      </div>
    );
  }

  renderCountryCodeOption(name, code) {
    return (
      <option key={code} value={code}>
        {name}
      </option>
    );
  }

  renderCountryCode() {
    const { classes } = this.props;

    return (
      <div className={classes.select}>
        <select className={classes.selectInput}>
          <option />
          {map(countryNames, this.renderCountryCodeOption)}
        </select>

        <SelectIcon className={classes.selectArrow} />
      </div>
    );
  }

  renderHiddenInput() {
    const { classes } = this.props;

    return <div className={classes.hidden}>Hidden field</div>;
  }

  renderLabel() {
    const { field } = this.props;
    const label = this.isHidden(field) ? field.slug : field.label;
    return <div className={this.getLabelClassName()}>{label}</div>;
  }

  renderInput() {
    const { field } = this.props;

    switch (field.type) {
      case 'company_size':
        return this.renderCompanySize();
      case 'country_code':
        return this.renderCountryCode();
      case 'checkbox':
        return this.renderCheckboxInput();
      case 'select':
        return this.renderSelectInput();
      case 'cookie':
      case 'param':
      case 'hidden':
        return this.renderHiddenInput();
      default:
        return this.renderPlaceholderInput();
    }
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderLabel()}
        {this.renderInput()}
      </div>
    );
  }
}

Field.propTypes = {
  classes: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Field);
